import React, { useState, useContext } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { JobDocumentsContext } from 'stores/JobDocumentsStore'
import { Button, FlexView } from 'components/common'
import { Input, Select, Checkbox } from 'components/form'
import { UploadDocumentButton } from '../uploadDocumentButton'
import moment from "moment"
import * as S from "./styles"

const DEFAULT_FORM_STATE = {
  jobType: '',
  country: '',
  oilField: '',
  well: '',
  wellSection: '',
  rig: '',
  drillingContractor: '',
  jobDate: '',
  fieldJobNumber: '', // ??
  area: '',
  od: '',
  idCustomer: '',
  showOnTlh: false,
}

export const NewJobModal = ({ show, close, closeAndUpdate, customers, ...props }) => {
  const [formState, setFormState] = useState(DEFAULT_FORM_STATE)
  const [jobDate, setJobDate] = useState(null)

  const { documentLoaded, createNewJob } = useContext(JobDocumentsContext)
  const { t } = useTranslation()

  const checkFields = () => {
    const keysForm = Object.keys(formState)
    let count = 11
    keysForm.forEach((item) => {
      if (item !== 'area' && item !== 'showOnTlh' && formState[item] !== '') {
        count--
      }
    })
    return count === 0 ? true : false
  }

  const onSendClick = async () => {
    if (checkFields()) {
      // eslint-disable-next-line no-unused-vars
      const { error, data } = await createNewJob({ ...formState, jobDate })
      if (error) {
        toast.error(t('upload.sendError'))
        return
      }
      setFormState(DEFAULT_FORM_STATE)
      setJobDate(null)
      toast.success(t('upload.sendSuccess'))
      closeAndUpdate({})
    } else {
      toast.error(t('jobUpload.error.form'))
    }
  }

  const handleInputChange = (event) => {
    event.persist()
    setFormState(currentState => ({
      ...currentState,
      [event.target.name]: event.target.value
    }))
  }

  const handleSelectCheckBox = (event) => {
    setFormState(currentState => ({
      ...currentState,
      'showOnTlh': !formState.showOnTlh
    }))
  }

  const handleSelectInput = name => value => {
    setFormState(currentState => ({
      ...currentState,
      [name]: value
    }))
  }

  const handleSelectDate = name => event => {
    if (event.target.value !== ""){
      event.persist()
      setJobDate(event.target.value)
      setFormState(currentState => ({
        ...currentState,
        [name]: moment(event.target.value).format("YYYY-MM-DD")
      }))
    }
 
  }

  // const  = name => value => {
  //   if (value.target.value !== "") {
  //     setJobDate(value.target.value)
  //     const date = value.target.value
  //     setFormState(currentState => ({
  //       ...currentState,
  //       [name]: date
  //     }))
  //

  if (!show) return null

  return (
    <S.BlackGlass>
      <S.ModalCard >
        <S.CloseButton onClick={() => {
          setJobDate(null)
          setFormState(DEFAULT_FORM_STATE)
          close()
        }}>X</S.CloseButton>

        <FlexView alignItems="center" justifyContent="center">
          <S.CardTitle>{t('upload.title')}</S.CardTitle>
        </FlexView>

        <FlexView flexDirection="column" alignItems="center" justifyContent="center">

          {/* Campos obrigatórios */}
          <FlexView flexDirection="row" width="90%" padding="4px 8px 0px"  >
            <Input
              margin="0px"
              label={t('upload.rigName') + "*"}
              width="100%" name="rig"
              value={formState.rig}
              onChange={handleInputChange}
            /> &nbsp;&nbsp;&nbsp;
            <Input
              margin="0px"
              label={t('upload.country') + "*"}
              width="100%"
              name="country"
              value={formState.country}
              onChange={handleInputChange} />
            &nbsp;&nbsp;&nbsp;
            <Input
              margin="0px"
              width="100%"
              label={t('upload.date') + "*"}
              name="jobDate"
              type="date"
              value={formState.jobDate}
              onChange={handleSelectDate('jobDate')}
            />
                      &nbsp;&nbsp;&nbsp;
            <Select
              margin="0px"
              label={t('upload.company') + "*"}
              options={customers.map(c => ({ value: c.id, label: c.description }))}
              onChange={handleSelectInput('idCustomer')}
              value={formState.idCustomer} width="40%"
            />
          </FlexView>


          <FlexView flexDirection="row" width="90%" padding="4px 8px 0px">
            <Input
              margin="0px"
              label={t('upload.fieldJobNumber') + "*"}
              width="95%"
              name="fieldJobNumber"
              value={formState.fieldJobNumber}
              onChange={handleInputChange} />
            <Input
              margin="0px"
              label={t('upload.oilField') + "*"}
              width="100%"
              name="oilField"
              value={formState.oilField}
              onChange={handleInputChange}
            /> &nbsp;&nbsp;&nbsp;
            <Select
              margin="0px"
              label={t('upload.type') + "*"}
              options={[
                { label: 'Offshore', value: 'Offshore' },
                { label: 'OnShore', value: 'OnShore' },
              ]}
              onChange={handleSelectInput('jobType')}
              value={formState.jobType}
              width="40%"
            />
          </FlexView>

          <FlexView flexDirection="row" width="90%" padding="4px 8px 0px">
            <Input
              margin="0px"
              label={t('upload.drillingContractor') + "*"}
              width="100%"
              name="drillingContractor"
              value={formState.drillingContractor}
              onChange={handleInputChange} />
            &nbsp;&nbsp;&nbsp;
            <Input
              margin="0px"
              label={t('upload.well') + "*"}
              width="100%"
              name="well"
              value={formState.well}
              onChange={handleInputChange} />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Input
              margin="0px"
              label={t('upload.wellSection') + "*"}
              width="100%"
              name="wellSection"
              value={formState.wellSection}
              onChange={handleInputChange} />
          </FlexView>

          <FlexView flexDirection="row" width="90%" padding="4px 8px 0px">
            {/* Area não é obrigatório */}
            <Input
              margin="0px"
              label={t('upload.area')}
              width="100%"
              name="area"
              value={formState.area}
              onChange={handleInputChange} />
            &nbsp;&nbsp;&nbsp;
            <Input
              margin="0px"
              label={t('upload.od') + "*"}
              width="100%"
              name="od"
              value={formState.od}
              onChange={handleInputChange} />
          </FlexView>

          <FlexView flexDirection="row" width="90%" padding="4px 8px 0px">
            <Checkbox margin="0px" label={t('upload.showTlh')} name="showOnTlh" value={formState.showOnTlh} onChange={handleSelectCheckBox} checked={formState.showOnTlh} />
          </FlexView>

          <FlexView margin="30px 8px 0px" flexDirection="row" width="90%" justifyContent="space-between">
            <UploadDocumentButton />

            {documentLoaded && (
              <Button
                alignSelf="flex-end"
                backgroundColor="primary"
                color="white"
                fontSize="big"
                onClick={onSendClick}
              >
                {t('upload.send')}
              </Button>
            )}
          </FlexView>
        </FlexView>
      </S.ModalCard >
    </S.BlackGlass>
  )
}